import { render, staticRenderFns } from "./settings-dialog-integration-crm.vue?vue&type=template&id=6b8d183d&scoped=true&"
import script from "./settings-dialog-integration-crm.vue?vue&type=script&lang=js&"
export * from "./settings-dialog-integration-crm.vue?vue&type=script&lang=js&"
import style0 from "./settings-dialog-integration-crm.vue?vue&type=style&index=0&id=6b8d183d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8d183d",
  null
  
)

export default component.exports